import PublicationsField from './PublicationsField.component';

export default PublicationsField;